import { Controller } from "@hotwired/stimulus"
import { lockScroll, unlockScroll } from "../utils/scroll_lock"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.boundClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.boundClickOutside)

    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
    document.removeEventListener("keydown", this.boundKeydown)

    if (this.hasModalTarget && !this.modalTarget.classList.contains("hidden")) {
      unlockScroll()
    }
  }

  open(event) {
    if (event) {
      event.preventDefault()
    }

    const modal = this.modalTarget
    if (!modal) return

    const form = modal.querySelector("form")
    if (form) form.reset()

    modal.classList.remove("hidden")
    modal.setAttribute("aria-hidden", "false")
    lockScroll()

    const firstInput = modal.querySelector(
      'input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled])'
    )
    const firstFocusable =
      firstInput ||
      modal.querySelector('button, [href], [tabindex]:not([tabindex="-1"])')

    if (firstFocusable) {
      firstFocusable.focus()
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }

    if (!this.hasModalTarget) return

    this.modalTarget.classList.add("hidden")
    this.modalTarget.setAttribute("aria-hidden", "true")
    unlockScroll()
  }

  handleClickOutside(event) {
    if (!this.hasModalTarget || this.modalTarget.classList.contains("hidden")) return

    const dialog = this.modalTarget.querySelector("[data-modal-dialog]")

    if (dialog) {
      if (dialog.contains(event.target)) return
      if (this.modalTarget.contains(event.target)) this.close()
      return
    }

    if (event.target.classList.contains("fixed") && event.target.classList.contains("inset-0")) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.hasModalTarget && !this.modalTarget.classList.contains("hidden")) {
      this.close()
    }
  }
}
